import { RouteConfig } from 'vue-router';
import Overview from '@/views/management/ManagementOverview.vue';
import CustomerCreate from '@/views/management/Customer/CustomerCreate.vue';
import CustomerEdit from '@/views/management/Customer/CustomerEdit.vue';
import CustomerOverview from '@/views/management/Customer/CustomerOverview.vue';
import VehiclesEdit from '@/views/management/Customer/Vehicles/VehiclesEdit.vue';
import ProcessEdit from '@/views/management/Process/ProcessEdit.vue';
import PageModal from '@/components/modals/PageModal.vue';
import Thumbnail from '@/components/damagecases/edit/Thumbnail.vue';
import LawyerOffice from '@/components/damagecases/edit/LawyerOffice.vue';
import OppositeInsurance from '@/components/damagecases/edit/OppositeInsurance.vue';
import Accident from '@/components/damagecases/edit/Accident.vue';
import TransactionKey from '@/components/damagecases/edit/TransactionKey.vue';
import CustomerConsultant from '@/components/damagecases/edit/CustomerConsultant.vue';
import RepairExtensions from '@/components/damagecases/edit/RepairExtensions.vue';
import WorkingImages from '@/components/damagecases/edit/WorkingImages.vue';
import RepairProofs from '@/components/damagecases/edit/RepairProofs.vue';
import ProcessRepairPlanModal from '@/views/management/Process/ProcessRepairPlanModal.vue';
import DamageAssessor from '@/components/damagecases/edit/DamageAssessor.vue';
import RepairShop from '@/components/damagecases/edit/RepairShop.vue';
import RepairExtensionMailerLawer from '@/components/damagecases/edit/RepairExtensionMailLawyer.vue';
import RepairPlanOrderForm from '@/components/damagecases/forms/RepairPlanOrderForm.vue';
import RepairApproval from '@/views/damagecases/RepairApproval.vue';
import Warning from '@/views/damagecases/Warning.vue';
import store from '@/store/index';
import Payment from '@/views/damagecases/Payment.vue';
import DamagecaseCreate from '@/views/damagecases/Create.vue';
import ProcessCreateOrderDocumentation from '@/views/management/Process/OrderDocumentation/ProcessCreateOrderDocumentation.vue';
import ProcessCreateComprehensive from '@/views/management/Process/Comprehensive/ProcessCreateComprehensive.vue';
import VehiclesCreate from '@/views/management/Customer/Vehicles/VehiclesCreate.vue';
import CreateChat from '@/views/management/RepairShop/Chat/CreateChat.vue';
import InformationModal from '@/views/management/Customer/InformationModal.vue';
import CreateDocuments from '@/views/damagecases/CreateDocuments.vue';
import KilometrageChangeCard from '@/views/management/Customer/Vehicles/KilometrageChangeCard.vue';
import RotatePicturesModal from '@/views/management/Process/Document/RotatePicturesModal.vue';
import ProcessDocumentSign from '@/views/management/Process/Document/ProcessDocumentSign.vue';
import QRModal from '@/views/management/Customer/QRModal.vue';
import CustomerPermissionModal from '@/views/management/CustomerPermissionModal.vue';
import NoteEdit from '@/components/damagecases/edit/NoteEdit.vue';
import AdminSystemSettings from '@/views/adminSettings/AdminSystemSettings.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/management/',
		name: 'management',
		component: Overview,
	},
	{
		path: '/management/customer/create/:customer?',
		name: 'management.customer.create',
		component: CustomerCreate,
	},
	{
		path: '/management/customer/edit/:customer',
		name: 'management.customer.edit',
		component: CustomerEdit,
	},
	{
		path: '/management/customer/overview/:customer',
		name: 'management.customer.overview',
		component: CustomerOverview,
		children: [
			{
				path: 'create_chat/:customerid',
				name: 'management.customer.overview.create_chat',
				component: PageModal,
				props: {
					component: CreateChat,
					title: 'Chat hinzufügen',
					saveButtonText: 'Versenden',
					props: true,
				},
			},
			{
				path: 'process-info',
				name: 'management.customer.overview.process_info',
				component: PageModal,
				props: {
					title: 'Vorgang spezifizieren',
					component: InformationModal,
					modalStyle: 'width: fit-content; align-self: center',
				},
				meta: {
					action: 'new',
				},
			},
			{
				path: 'show_qr',
				name: 'management.customer.overview.show_qr',
				component: PageModal,
				props: {
					component: QRModal,
					title: 'Kunden-App',
					props: true,
					modalStyle: 'width: fit-content; align-self: center',
				},
				meta: { disableScroll: true },
			},
			{
				path: 'set_permission',
				name: 'management.customer.overview.set_permission',
				component: PageModal,
				props: {
					component: CustomerPermissionModal,
					title: 'Medienversand konfigurieren',
					props: true,
				},
				meta: { disableScroll: true },
			},
		],
	},
	{
		path: '/management/customer/:customer/vehicles/:vehicleId',
		name: 'management.customer.vehicles.edit',
		component: VehiclesEdit,
		children: [
			{
				path: 'kilometrageChange',
				name: 'management.customer.vehicles.edit.kilometrageChange',
				component: PageModal,
				props: {
					title: 'Tachostand - Änderungshistorie',
					component: KilometrageChangeCard,
					modalStyle: 'width: fit-content; align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: { disableScroll: true },
			},
		],
	},
	{
		path: '/management/customer/overview/:customer/process/:processId',
		name: 'management.process.edit',
		component: ProcessEdit,
		children: [
			{
				path: 'thumbnail',
				name: 'damagecases.edit.thumbnail',
				component: PageModal,
				props: {
					title: 'Vorgang - Übersichtsfoto ändern',
					component: Thumbnail,
				},
			},
			{
				path: 'lawyerOffice',
				name: 'damagecases.edit.lawyerOffice',
				component: PageModal,
				props: {
					title: 'Vorgang - Anwalt anpassen',
					component: LawyerOffice,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'oppositeInsurance',
				name: 'damagecases.edit.oppositeInsurance',
				component: PageModal,
				props: {
					title: () => `Vorgang - ${store.getters.isProcessComprehensive ? 'Kasko' : 'gegnerische'} Versicherung anpassen `,
					component: OppositeInsurance,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'accident',
				name: 'damagecases.edit.accident',
				component: PageModal,
				props: {
					title: 'Vorgang - Angaben zum Unfall anpassen',
					component: Accident,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'transactionKey',
				name: 'damagecases.edit.transactionKey',
				component: PageModal,
				props: {
					title: () =>
						store.getters.isProcessOrderDocumentation ? 'Auftragsdokumentation - Aktenzeichen ändern' : 'Vorgang - Aktenzeichen ändern',
					component: TransactionKey,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'customerConsultant',
				name: 'damagecases.edit.customerConsultant',
				component: PageModal,
				props: {
					title: 'Vorgang - Kundendienstberater anpassen',
					component: CustomerConsultant,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'repairExtensions',
				name: 'damagecases.edit.repairExtensions',
				component: PageModal,
				props: {
					title: 'Reparatur-Erweiterungen',
					component: RepairExtensions,
					props: true,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'workingImages',
				name: 'damagecases.edit.workingImages',
				component: PageModal,
				props: {
					title: 'Arbeitsfotos',
					component: WorkingImages,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'repairProofs',
				name: 'damagecases.edit.repairProofs',
				component: PageModal,
				props: {
					title: 'Fotos des Reparaturbetriebes zur Bestätigung der Reparatur',
					component: RepairProofs,
					hint: () =>
						store.getters.isProcessLiability
							? 'Versicherungen zweifeln Reparaturen gerne an obwohl ggfs. eine Rechnung vorliegt. ' +
							  'Wenn aber Sie als Betrieb direkt nach der Reparatur Fotos anfertigen, kann ein Gutachter anhand dieser Bilder eine Reparaturbestätigung erstellen.<br><br> Das ist insbesondere hilfreich, ' +
							  'wenn das Auto zeitnah einen weiteren Unfall erleidet und man Beweis erbringen muss, dass tatsächlich repariert wurde. Daher sind diese Fotos für den Kunden aber' +
							  ' auch für Sie als Autohaus / Reparaturbetrieb von immenser Bedeutung. <br><br>Mindestvoraussetzung für eine Bestätigung sind 4 Übersichtsfotos sowie ein Foto vom KM‐Stand. ' +
							  '<br>Sinnvoll ist es allerdings, weitere Fotos von der konkret zuvor verunfallten Stelle hochzuladen.'
							: 'Wenn Sie als Betrieb direkt nach der Reparatur Fotos anfertigen, kann ein Gutachter anhand dieser Bilder eine Reparaturbestätigung erstellen; natürlich können Sie auch selbst diese Bilder der Versicherung zur Verfügung stellen.<br><br> Das ist insbesondere hilfreich, ' +
							  'wenn das Auto zeitnah einen weiteren Unfall erleidet und man Beweis erbringen muss, dass tatsächlich repariert wurde. Daher sind diese Fotos für den Kunden aber' +
							  ' auch für Sie als Autohaus / Reparaturbetrieb von immenser Bedeutung.<br><br>Mindestvoraussetzung für eine Bestätigung sind 4 Übersichtsfotos sowie ein Foto vom KM-Stand. ' +
							  '<br>Sinnvoll ist es allerdings, weitere Fotos von der konkret zuvor verunfallten Stelle hochzuladen.',
				},
				meta: { disableScroll: true },
			},
			{
				path: 'repairplan',
				name: 'damagecases.repairplan',
				component: PageModal,
				props: {
					title: 'Reparatur-Ablaufplan',
					component: ProcessRepairPlanModal,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'damageAssessor',
				name: 'damagecases.edit.damageAssessor',
				component: PageModal,
				props: {
					title: () => (store.getters.getAuthenticatedUserGroupLevel === '2' ? 'Vorgang - Gutachter anpassen' : 'Vorgang - Gutachterfirma anpassen'),
					component: DamageAssessor,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'repairShop',
				name: 'damagecases.edit.repairShop',
				component: PageModal,
				props: {
					title: 'Vorgang - ' + store.getters.getDamageCaseRepairShopLabel + ' anpassen',
					component: RepairShop,
				},
				meta: {
					disableScroll: true,
					levelGuard: [1, 2],
				},
			},
			{
				path: 'notes/:noteId?',
				name: 'damagecases.edit.notes',
				component: PageModal,
				props: {
					title: 'Vorgang - Notizen anpassen',
					component: NoteEdit,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'repairExtensions/:extensionID/mail',
				name: 'damagecases.edit.repairExtensions.mail',
				component: PageModal,
				props: {
					title: 'Anwalt benachrichtigen',
					component: RepairExtensionMailerLawer,
					saveButtonText: 'Mail mit Anhängen an den Anwalt verschicken',
				},
				meta: { disableScroll: true },
			},
			{
				path: 'repairplanorderform',
				name: 'damagecases.repairplan.orderform',
				component: PageModal,
				props: {
					title: 'Bestellformular',
					component: RepairPlanOrderForm,
					saveButtonText: 'PDF erstellen',
				},
				meta: { disableScroll: true },
			},
			{
				path: 'repairapproval',
				name: 'damagecases.repairapproval',
				component: PageModal,
				props: {
					title: 'Kalkulation bereitstellen & Mietwagenklasse definieren',
					component: RepairApproval,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'dunning',
				name: 'damagecases.dunning',
				component: PageModal,
				props: {
					title: 'Mahnwesen',
					component: Warning,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'payment/:type?',
				name: 'damagecases.payment',
				component: PageModal,
				props: {
					title: 'OPOS Verwaltung',
					component: Payment,
				},
				meta: { disableScroll: true },
			},
			{
				path: 'rotatepictures',
				name: 'damagecases.rotatepictures',
				component: PageModal,
				props: {
					title: 'Bildausrichtung anpassen',
					hint: 'Bite richten Sie das Bild hochkant aus',
					component: RotatePicturesModal,
				},
				meta: { disableScroll: true },
			},
		],
	},
	{
		path: '/management/process/create/liability/:customer?',
		name: 'management.process.create',
		component: DamagecaseCreate,
		meta: {
			action: 'new',
		},
	},
	{
		path: '/management/process/create/order_documentation/:customer?',
		name: 'management.process.order_documentation',
		component: ProcessCreateOrderDocumentation,
	},
	{
		path: '/management/process/create/comprehensive/:customer?',
		name: 'management.process.create_comprehensive',
		component: ProcessCreateComprehensive,
	},
	{
		path: '/management/process/create-documents/:customer?',
		name: 'management.process.create-documents',
		component: CreateDocuments,
		meta: {
			action: 'new',
		},
	},
	{
		path: '/management/:customerId/process/:processId/sign',
		name: 'management.process.sign_documents',
		component: ProcessDocumentSign,
	},
	{
		path: '/management/process/create/vehicle/:customer?',
		name: 'management.process.create_vehicle',
		component: VehiclesCreate,
	},
	{
		path: '/admin-system-settings',
		name: 'adminSystemSettings',
		component: AdminSystemSettings,
	},
];

export default routes;
